import axios from "axios";
import { __constants } from "../constants";
import { createQuery } from "../utils";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const getReportListing = async (query) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/reports?limit=" + __constants.listingLimit + "&" + createQuery(query),
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            }
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const updateReportStatus = async (reportId, data) => {
    try {
        const config = {
            method: 'PUT',
            url: BASE_URL + "/v1/admin/reports/" + reportId,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}

